import { useAtsConversationApi } from '@/composables/useApi';
import { InternalError } from '@/core/shared/errors/internal.error';
import type { EmployerScreeningQuestion } from './employer-screening-question.type';

export default class EmployerScreeningQuestionsPersistence {
  private employerId: number;

  constructor(employerId: number) {
    this.employerId = employerId;
  }

  public async fetchFrequentlyUsedQuestions(): Promise<EmployerScreeningQuestion[]> {
    const url = `static-screening/employer/${this.employerId}/frequent-questions`;
    const { data, error, statusCode } = await useAtsConversationApi(url)
      .get()
      .json<EmployerScreeningQuestion[]>();

    if (error.value) {
      throw new InternalError('Failed to fetch frequently used questions', {
        error: error.value,
        status: statusCode.value,
      });
    }

    return data.value ?? [];
  }
}
